module.exports = __webpack_public_path__ + "static/AkkuratPro-Italic-25bfc6b31267683c095473fcd3e2697b.woff";